import { render, staticRenderFns } from "./Carousell.vue?vue&type=template&id=0616e4ee&scoped=true&"
import script from "./Carousell.vue?vue&type=script&lang=js&"
export * from "./Carousell.vue?vue&type=script&lang=js&"
import style0 from "./Carousell.vue?vue&type=style&index=0&id=0616e4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616e4ee",
  null
  
)

export default component.exports